import { ReactNode } from "react";
import BlurredCircle from "../BlurredCircle";
import Container from "../Container";

export default function BannerContainer({ children }: { children: ReactNode }) {
  return (
    <section className="min-h-[75vh] flex items-center relative">
      <BlurredCircle />

      <Container>{children}</Container>
    </section>
  );
}
